/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum GeneratePatientRefusalAliases {
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  FRAGMENT_INFORMATION_BAR_HEADER = 'fragment-information-bar-header',
  GENERATE_PATIENT_REFUSAL_LAYOUT = 'generate-patient-refusal-layout',
  MEDICATION_HEADER_FRAGMENT = 'medication-header-fragment',
  PANEL_CONTAINER_INFORMATION_BAR_HEADER = 'panel-container-information-bar-header',
  PANEL_INFORMATION_BAR_HEADER = 'panel-information-bar-header',
  REFUSAL_MEDICATION_FORM = 'refusal-medication-form',
  REFUSAL_MEDICATION_FORM_PANEL = 'refusal-medication-form-panel',
  REFUSAL_MEDICATION_JUSTIFICATION_FIELD = 'refusal-medication-justification-field',
  REFUSAL_MEDICATION_JUSTIFICATION_TEXT_AREA = 'refusal-medication-justification-text-area',
}
export { GeneratePatientRefusalAliases };
